import { render, staticRenderFns } from "./AdminClinicSelect.vue?vue&type=template&id=34478b7e&"
import script from "./AdminClinicSelect.vue?vue&type=script&lang=js&"
export * from "./AdminClinicSelect.vue?vue&type=script&lang=js&"
import style0 from "./AdminClinicSelect.vue?vue&type=style&index=0&id=34478b7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports